import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import * as yup from "yup";
import { DecodeToken } from "../../DecodeToken";
import { enregistrerrepas } from "../../services/restauratrice/RestauratriceRequest";
import {
  enregistrerrepasvendeuse,
  recherchertouteslesvendeuses,
  recherchervendeuseautorises,
} from "../../services/vendeuses/VendeuseRequest";
import { returnImageLink } from "../ReturnImageLink";
import { Oval } from "react-loader-spinner";
import {
  rechercherentreprises,
  rechercherentreprisespartenaires,
} from "../../services/entreprises/entrepriseRequest";
import { recherchertouslesRestaurants } from "../../services/restaurants/RestaurantRequest";

function PlatAdd(props) {
  const [errorMessage, setErrorMessage] = useState("");
  const [fileUploaded, setfileUploaded] = useState(null);
  const [fileName, setfileName] = useState(null);
  const [vendeuseSelected, setvendeuseSelected] = useState(null);
  const [entrepriseSelected, setEntrepriseSelected] = useState(null);
  const [restaurantSelected, setRestaurantSelected] = useState(null);
  const [loading, setloading] = useState(false);
  const [listeVendeur, setlisteVendeur] = useState([]);
  const [listeEntreprise, setListeEntreprise] = useState([]);
  const [listeRestaurant, setListeRestaurant] = useState([]);
  let [typeDeRepas, setTypeDeRepas] = useState([
    { idrepas: 1, titre: "Entrée", value: "ENTREE" },
    { idrepas: 2, titre: "Plat de résistance", value: "PLAT" },
    { idrepas: 3, titre: "Dessert", value: "DESSERT" },
    { idrepas: 4, titre: "Boisson", value: "BOISSON" },
  ]);
  let [Repas, setRepas] = useState("");

  const openDirectorieFile = () => {
    let input = document.createElement("input");
    input.type = "file";
    input.onchange = (_) => {
      // you can use this method to get file and perform respective operations
      let files = Array.from(input.files);
      setfileUploaded(URL.createObjectURL(files[0]));
      setfileName(files[0]);
    };
    input.click();
  };

  // Récupère la liste des vendeuses
  const afficherVendeur = () => {
    if (DecodeToken().profil === "ROLE_ADMIN") {
      recherchertouteslesvendeuses().then((response) => {
        setlisteVendeur(response.data.donnee);
      });
    } else {
      recherchervendeuseautorises().then((response) => {
        setlisteVendeur(response.data.donnee);
      });
    }
  };

  // Récupère la liste des entreprises
  const afficherEntreprise = () => {
    if (DecodeToken().profil === "ROLE_ADMIN") {
      rechercherentreprises()
        .then((response) => {
          setListeEntreprise(response.data.donnee);
        })
        .catch((error) => {
          console.log("ERROR", error);
        });
    } else {
      rechercherentreprisespartenaires().then((res) => {
        setListeEntreprise(res.data.donnee);
      });
    }
  };

  // Récupère la liste de srestau
  const afficherRestaurant = () => {
    recherchertouslesRestaurants()
      .then((response) => {
        setListeRestaurant(response.data.donnee);
      })
      .catch((error) => {
        console.log("ERROR", error);
      });
  };

  const initialValues = {
    id: props.infoPlat.id !== undefined ? props.infoPlat.id : "",
    designation:
      props.infoPlat.designation !== undefined
        ? props.infoPlat.designation
        : "",
    prix: props.infoPlat.prix !== undefined ? props.infoPlat.prix : "",
    fichierId: props.infoPlat.image ? props.infoPlat.image.id : "",
    typeRepas:
      props.infoPlat.typeRepas !== undefined ? props.infoPlat.typeRepas : "",
    restaurantId: props.infoPlat.restaurant ? props.infoPlat.restaurant.id : "",
  };

  const validationSchemaValues = yup.object().shape({
    designation: yup.string().required("Veuillez saisir la désignation"),
    prix: yup.number().required("Veuillez saisir un prix"),
  });

  const setHandleChoixRestau = (value) => {
    setRestaurantSelected(value);
    setvendeuseSelected(null);
  };

  const setHandleChoixVendeuse = (value) => {
    setvendeuseSelected(value);
    setRestaurantSelected(null);
  };

  const onSubmitPlat = (values) => {
    setloading(true);
    let dataToSave = new FormData();
    dataToSave.append("id", values.id);
    dataToSave.append("designation", values.designation);
    dataToSave.append("prix", values.prix);
    dataToSave.append("fichierId", values.fichierId);
    dataToSave.append("typeRepas", values.typeRepas);
    dataToSave.append("visuel", fileName);
    setErrorMessage("");
    if (DecodeToken().profil !== "ROLE_ADMIN") {
      props.infoPlat.id === undefined
        ? dataToSave.append(
          "entrepriseId",
          entrepriseSelected && entrepriseSelected.id ? entrepriseSelected.id : ""
        )
        : dataToSave.append(
          "entrepriseId",
          entrepriseSelected && entrepriseSelected.id ? entrepriseSelected.id : ""
        );
      enregistrerrepas(dataToSave)
        .then((res) => {
          setloading(false);
          setfileUploaded(null);
          props.actualiserliste();
          setfileName(null);
          props.funLienImage("");
          props.setinfoPlat({});
          setErrorMessage("");
          setEntrepriseSelected(null);
          props.infoPlat.id == undefined &&
            document.getElementById("reinitialiseFormAddPlat").click();
        })
        .catch((error) => {
          setloading(false);
          console.log("error", error);
          if (error && error.response) {
            setErrorMessage(error.response.data.donnee)
          } else {
            setErrorMessage("Une erreur s'est produite, impossible d'ajouter le plat")
          }
        });
    } else {
      if (
        (props.infoPlat.id !== undefined && restaurantSelected) ||
        (props.infoPlat.id !== undefined && vendeuseSelected)
      ) {
        props.infoPlat.id === undefined
          ? dataToSave.append(
            "vendeuseId",
            vendeuseSelected && vendeuseSelected.id ? vendeuseSelected.id : ""
          )
          : dataToSave.append(
            "vendeuseId",
            props.infoPlat.vendeuse && props.infoPlat.vendeuse.id ? props.infoPlat.vendeuse.id : ""
          );
        props.infoPlat.id === undefined
          ? dataToSave.append(
            "entrepriseId",
            entrepriseSelected && entrepriseSelected.id ? entrepriseSelected.id : ""
          )
          : dataToSave.append(
            "entrepriseId",
            props.infoPlat.entreprise ? props.infoPlat.entreprise.id : ""
          );
        props.infoPlat.id === undefined
          ? dataToSave.append(
            "restaurantId",
            restaurantSelected && restaurantSelected.id ? restaurantSelected.id : ""
          )
          : dataToSave.append(
            "restaurantId",
            props.infoPlat.restaurant && props.infoPlat.restaurant.id  ? props.infoPlat.restaurant.id : ""
          );
        setErrorMessage("");
        enregistrerrepasvendeuse(dataToSave)
          .then((res) => {
            setloading(false);
            setfileUploaded(null);
            props.vendeuseSelected === null
              ? props.actualiserliste()
              : props.actualiserlisteparvendeuse(props.vendeuseSelected.id);

            setfileName(null);
            setvendeuseSelected([]);
            props.funLienImage("");
            props.setinfoPlat({});
            setErrorMessage("");
            props.infoPlat.id == undefined &&
              document.getElementById("reinitialiseFormAddPlat").click();
          })
          .catch((error) => {
            setloading(false);
            console.log("error", error);
            if (error && error.response) {
              setErrorMessage(error.response.data.donnee)
            } else {
              setErrorMessage("Une erreur s'est produite, impossible d'ajouter le plat")
            }
          });
      } else if (
        props.infoPlat.id === undefined &&
        restaurantSelected === null &&
        vendeuseSelected === null
      ) {
        setloading(false);
      } else if (
        (props.infoPlat.id === undefined && restaurantSelected) ||
        (props.infoPlat.id === undefined && vendeuseSelected)
      ) {
        let dataToSave = new FormData();
        dataToSave.append("id", values.id);
        dataToSave.append("designation", values.designation);
        dataToSave.append("prix", values.prix);
        dataToSave.append("fichierId", values.fichierId);
        dataToSave.append("typeRepas", values.typeRepas);
        dataToSave.append("visuel", fileName);
        setErrorMessage("");
        props.infoPlat.id === undefined
          ? dataToSave.append(
            "vendeuseId",
            vendeuseSelected && vendeuseSelected.id ? vendeuseSelected.id : ""
          )
          : dataToSave.append(
            "vendeuseId",
            props.infoPlat.vendeuse && props.infoPlat.vendeuse.id ? props.infoPlat.vendeuse.id : ""
          );
        props.infoPlat.id === undefined
          ? dataToSave.append(
            "entrepriseId",
            entrepriseSelected && entrepriseSelected.id ? entrepriseSelected.id : ""
          )
          : dataToSave.append(
            "entrepriseId",
            props.infoPlat.entreprise && props.infoPlat.entreprise.id ? props.infoPlat.entreprise.id : ""
          );
        props.infoPlat.id === undefined
          ? dataToSave.append(
            "restaurantId",
            restaurantSelected && restaurantSelected.id ? restaurantSelected.id : ""
          )
          : dataToSave.append(
            "restaurantId",
            props.infoPlat.restaurant && props.infoPlat.restaurant.id ? props.infoPlat.restaurant.id : ""
          );
        enregistrerrepasvendeuse(dataToSave)
          .then((res) => {
            setloading(false);
            setfileUploaded(null);
            props.vendeuseSelected === null
              ? props.actualiserliste()
              : props.actualiserlisteparvendeuse(props.vendeuseSelected.id);

            setfileName(null);
            setvendeuseSelected([]);
            props.funLienImage("");
            props.setinfoPlat({});
            setErrorMessage("");
            props.infoPlat.id == undefined &&
              document.getElementById("reinitialiseFormAddPlat").click();
          })
          .catch((error) => {
            setloading(false);
            console.log("error", error);
            if (error && error.response) {
              setErrorMessage(error.response.data.donnee)
            } else {
              setErrorMessage("Une erreur s'est produite, impossible d'ajouter le plat")
            }
          });
      } else {
        props.infoPlat.id === undefined
          ? dataToSave.append(
            "vendeuseId",
            vendeuseSelected !== null ? vendeuseSelected.id : ""
          )
          : dataToSave.append(
            "vendeuseId",
            props.infoPlat.vendeuse ? props.infoPlat.vendeuse.id : ""
          );
        props.infoPlat.id === undefined
          ? dataToSave.append(
            "entrepriseId",
            entrepriseSelected !== null ? entrepriseSelected.id : ""
          )
          : dataToSave.append(
            "entrepriseId",
            props.infoPlat.entreprise ? props.infoPlat.entreprise.id : ""
          );
        props.infoPlat.id === undefined
          ? dataToSave.append(
            "restaurantId",
            restaurantSelected !== null ? restaurantSelected.id : ""
          )
          : dataToSave.append(
            "restaurantId",
            props.infoPlat.restaurant ? props.infoPlat.restaurant.id : ""
          );
        setErrorMessage("");
        enregistrerrepasvendeuse(dataToSave)
          .then((res) => {
            setloading(false);
            setfileUploaded(null);
            props.vendeuseSelected === null
              ? props.actualiserliste()
              : props.actualiserlisteparvendeuse(props.vendeuseSelected.id);

            setfileName(null);
            setvendeuseSelected([]);
            props.funLienImage("");
            props.setinfoPlat({});
            setErrorMessage("");
            props.infoPlat.id == undefined &&
              document.getElementById("reinitialiseFormAddPlat").click();
          })
          .catch((error) => {
            setloading(false);
            console.log("THE R", error);
            if (error && error.response) {
              setErrorMessage(error.response.data.donnee)
            } else {
              setErrorMessage("Une erreur s'est produite, impossible d'ajouter le plat")
            }
          });
      }
    }
  };

  useEffect(() => {
    afficherVendeur();
    afficherEntreprise();
    if (DecodeToken().profil === "ROLE_ADMIN") {
      afficherRestaurant();
    }
    setEntrepriseSelected(props.infoPlat.entreprise !== null ? props.infoPlat.entreprise : null)
  }, [props.infoPlat]);

  return (
    <>
      <div>
        <div className="text-center pt-5">
          <svg
            width="54"
            height="38"
            viewBox="0 0 54 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.66668 24.3333C1.31306 24.3333 0.973917 24.4738 0.723868 24.7238C0.47382 24.9739 0.333344 25.313 0.333344 25.6666C0.333344 26.0203 0.47382 26.3594 0.723868 26.6095C0.973917 26.8595 1.31306 27 1.66668 27H5.66668C5.66668 29.829 6.79048 32.5421 8.79087 34.5424C10.7913 36.5428 13.5044 37.6666 16.3333 37.6666H37.6667C40.4957 37.6666 43.2088 36.5428 45.2092 34.5424C47.2095 32.5421 48.3334 29.829 48.3334 27H52.3334C52.687 27 53.0261 26.8595 53.2762 26.6095C53.5262 26.3594 53.6667 26.0203 53.6667 25.6666C53.6667 25.313 53.5262 24.9739 53.2762 24.7238C53.0261 24.4738 52.687 24.3333 52.3334 24.3333H1.66668Z"
              fill="black"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.8067 0.403992L27 0.999991L28.1934 1.59599L28.1907 1.59999L28.1747 1.63332L28.108 1.77999C27.7518 2.57549 27.4835 3.40754 27.308 4.26132C26.9934 5.83332 27.1094 7.22399 27.9427 8.05732C29.776 9.89066 29.66 12.5 29.308 14.2613C29.0784 15.3832 28.7177 16.4743 28.2334 17.512L28.2067 17.5693L28.1974 17.5867L28.1947 17.5933L28.1934 17.5947L27 17L25.8067 16.404L25.8094 16.4L25.8254 16.3667L25.892 16.22C26.2483 15.4245 26.5166 14.5924 26.692 13.7387C27.0067 12.1667 26.8907 10.776 26.0574 9.94266C24.224 8.10932 24.34 5.49999 24.692 3.73866C24.9217 2.61674 25.2823 1.5257 25.7667 0.487991L25.7934 0.430658L25.8027 0.413325L25.8054 0.407991L25.8067 0.405324V0.403992ZM15.2267 3.58799L16.3334 4.33466C17.4387 5.07999 17.44 5.07866 17.44 5.07866V5.07732V5.07866L17.4227 5.10532C17.3057 5.29194 17.1963 5.4832 17.0947 5.67866C16.8426 6.15715 16.6415 6.6608 16.4947 7.18132C16.1747 8.37066 16.2894 9.30932 17.1267 9.92799C19.2894 11.5307 19.1747 13.9267 18.7454 15.5147C18.5491 16.2203 18.2787 16.9032 17.9387 17.552C17.79 17.8378 17.6285 18.1167 17.4547 18.388L17.444 18.404L17.4414 18.4093L17.44 18.4107C17.44 18.4107 17.4387 18.4133 16.3334 17.6667C15.228 16.92 15.2267 16.9213 15.2267 16.9213L15.244 16.896L15.316 16.7813C15.4058 16.6309 15.4911 16.478 15.572 16.3227C15.7787 15.9253 16.016 15.392 16.172 14.8187C16.492 13.6293 16.3774 12.692 15.54 12.072C13.3774 10.4693 13.492 8.07466 13.9214 6.48532C14.1414 5.66932 14.4667 4.95199 14.728 4.44799C14.8769 4.1627 15.0384 3.8842 15.212 3.61332L15.2214 3.59732L15.2254 3.59066L15.228 3.58799H15.2267ZM37.8934 3.58799L39 4.33466C40.1054 5.07999 40.1067 5.07866 40.1067 5.07866V5.07732V5.07866L40.0894 5.10532C39.9724 5.29194 39.8629 5.4832 39.7614 5.67866C39.5093 6.15715 39.3082 6.6608 39.1614 7.18132C38.8414 8.37066 38.956 9.30932 39.7934 9.92799C41.956 11.5307 41.8414 13.9267 41.412 15.5147C41.2158 16.2203 40.9454 16.9032 40.6054 17.552C40.4571 17.8378 40.2961 18.1167 40.1227 18.388L40.112 18.404L40.108 18.4093L40.1067 18.4107C40.1067 18.4107 40.1054 18.4133 39 17.6667C37.8947 16.92 37.8934 16.9213 37.8934 16.9213L37.9107 16.896L37.9827 16.7813C38.0724 16.6309 38.1578 16.478 38.2387 16.3227C38.4454 15.9253 38.6827 15.392 38.8387 14.8187C39.1587 13.6293 39.044 12.692 38.2067 12.072C36.044 10.4693 36.1587 8.07466 36.588 6.48532C36.808 5.66932 37.1334 4.95199 37.3947 4.44799C37.5431 4.16273 37.7041 3.88423 37.8774 3.61332L37.888 3.59732L37.892 3.59066L37.8947 3.58799H37.8934Z"
              fill="black"
            />
          </svg>
        </div>
        <h6 className="text-center mt-2">Ajouter un nouveau plat</h6>
        <div className="mt-5">
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validationSchemaValues}
            onSubmit={onSubmitPlat}
          >
            {({ resetForm }) => (
              <Form>
                {/* <span className="text-danger">{messageError}</span> */}
                <div className="mb-3">
                  <Field
                    type="text"
                    name="designation"
                    id="designation"
                    placeholder="Nom"
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <div className="input-group mb-3">
                    <Field
                      type="text"
                      placeholder="Prix"
                      name="prix"
                      className="form-control loginborderright"
                      aria-label="Text input with checkbox"
                    />
                    <div className="input-group-text bg-white">FCFA</div>
                  </div>
                </div>
                <span className="mb-1">Image</span>
                <div
                  className="mb-3 text-center rounded cursor px-5 py-3"
                  onClick={openDirectorieFile}
                  style={{ border: " 2px dashed #9f9f9f" }}
                >
                  {fileUploaded != null || props.lienImage != "" ? (
                    <img
                      src={
                        props.lienImage != "" ? props.lienImage : fileUploaded
                      }
                      alt="Image à charger"
                      className="img-fluid"
                    />
                  ) : (
                    <i className="fa fa-plus"></i>
                  )}
                </div>
                {DecodeToken().profil === "ROLE_ADMIN" &&
                  props.infoPlat.id == undefined && (
                    <div className="mb-2">
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={listeVendeur}
                        getOptionLabel={(option) => option.nomPrenoms ?? option}
                        value={vendeuseSelected}
                        onChange={(event, value) =>
                          setHandleChoixVendeuse(value)
                        }
                        sx={{
                          width: props.width !== undefined ? props.width : 250,
                        }}
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="bg-white"
                            label="Vendeuses"
                          />
                        )}
                      />
                      <div className="mt-2">
                        <Autocomplete
                          name="restaurantId"
                          id="combo-box-demo"
                          options={listeRestaurant}
                          getOptionLabel={(option) => option.nom ?? option}
                          value={restaurantSelected}
                          onChange={(event, value) =>
                            setHandleChoixRestau(value)
                          }
                          sx={{
                            width:
                              props.width !== undefined ? props.width : 250,
                          }}
                          size="small"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="bg-white"
                              label="Restaurants"
                            />
                          )}
                        />
                      </div>
                    </div>
                  )}
                <div className="mb-3">
                  <Autocomplete
                    name="entrepriseId"
                    id="combo-box-demo"
                    options={listeEntreprise}
                    getOptionLabel={(option) =>
                      option.raisonSociale ?? option
                    }
                    value={entrepriseSelected}
                    onChange={(event, value) => setEntrepriseSelected(value)}
                    sx={{
                      width: props.width !== undefined ? props.width : 250,
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className="bg-white"
                        label="Entreprises"
                      />
                    )}
                  />
                </div>
                <div className="mb-3">
                  <div className="input-group mb-3">
                    <Field
                      as="select"
                      name="typeRepas"
                      className="form-control loginborderright cursor"
                      aria-label="Text input with checkbox"
                    >
                      <option disabled selected value="">
                        Type de repas
                      </option>
                      <option disabled value=""></option>
                      {typeDeRepas.map((item, index) => (
                        <option value={item.value} key={index}>
                          {item.titre}
                        </option>
                      ))}
                    </Field>
                    <div className="text-danger">
                      <ErrorMessage name="typeRepas"></ErrorMessage>{" "}
                    </div>
                  </div>
                </div>

                {errorMessage.length !== 0 ? <p className="mt-3 text-danger text-center">{errorMessage}</p> : null}


                <div className="row justify-content-center mt-4">
                  <button
                    type="button"
                    className="btn"
                    id="reinitialiseFormAddPlat"
                    onClick={resetForm}
                    hidden
                  ></button>
                  <Oval
                    width={40}
                    height={40}
                    color="#CE5D1D"
                    visible={loading}
                  />
                  {!loading && (
                    <button type="submit" className="btn btn-rose text-white">
                      ENREGISTRER
                    </button>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
}

export default PlatAdd;
